import * as React from "react";
import Skeleton from "react-loading-skeleton";
import "./loader.css";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

export const GeoSearchCardLoader = () => {
  return (
    <Col className="col-12">
      <div className="info-card white-background geo-search-card">
        <Row>
          <Col className="col-12 card-content">
            <h4>
              <Skeleton count={1} width={"65%"} />
            </h4>
            <Skeleton count={1} width={"40%"} height={10} />
            <Skeleton count={1} width={"65%"} height={10} />
            <Skeleton count={1} width={"40%"} height={10} />
          </Col>
        </Row>
        <Row>
          <Col className="text-right" md="12" sm="12" xs="12">
            <Skeleton count={1} width={"35%"} height={30} />
          </Col>
        </Row>
      </div>
    </Col>
  );
};



// WEBPACK FOOTER //
// ./src/share/components/ChartLoader/GeoSearchCardLoader.tsx